import { mapStageToEnvironment } from '@zep/feature-flag';

export const FEATURE_FLAG_SERVER_URL =
  process.env.NEXT_PUBLIC_FEATURE_FLAG_URL ?? '';
export const SERVER_FEATURE_FLAG_EVALUATION_URL =
  process.env.FLIPT_SERVER_URL ?? 'https://flipt.zep.us';
export const FEATURE_FLAG_NAMESPACE = 'quiz';
export const FEATURE_FLAG_ENVIRONMENT =
  process.env.VERCEL_ENV === 'preview'
    ? 'dev'
    : mapStageToEnvironment(process.env.NEXT_PUBLIC_STAGE);
